import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59082da1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { class: "textbox-container" }

import { PropType, computed } from "vue";
import { FieldSize } from "@/enums/system/FieldSize";
import { DxTextArea } from "devextreme-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'acquaint-info-text-area',
  props: {
  /**
   * The text content displayed within the component.
   * @type {string}
   * @required
   */
  text: {
    type: String,
    required: true,
  },
  /**
   * The width of the component, defined by the `FieldSize` enum.
   * @type {FieldSize}
   * @default FieldSize.Full
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * The height of the component.
   * @type {String}
   * @default undefined
   */
  height: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;



const autoResize = computed(() => !props.height);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DxTextArea), {
        value: __props.text,
        height: __props.height,
        width: __props.width,
        "read-only": true,
        "auto-resize-enabled": autoResize.value
      }, null, 8, ["value", "height", "width", "auto-resize-enabled"])
    ])
  ]))
}
}

})